import IntegrationTable from '@/components/shared/IntegrationTable/IntegrationTable';
import { integrationFieldPresets } from '@/components/shared/IntegrationTable/integrationFieldPresets';
import { useTranslation } from 'react-i18next';
import Enotas from '../icons/Enotas';

export default function EnotasPage() {
  const { t } = useTranslation(['common', 'integration']);
  return (
    <IntegrationTable
      integrationKey="enotas"
      title="eNotas"
      main_icon={<Enotas />}
      icon={<Enotas />}
      fields={[
        integrationFieldPresets.access_token,
        integrationFieldPresets.metadata,
        integrationFieldPresets.status,
      ]}
      fixedValues={{
        active_statuses: ['paid'],
        payment_methods: ['credit_card', 'pix', 'bank_slip'],
      }}
      fieldLabels={{
        access_token: t('label_api_key'),
        placeholder_access_token: t('placeholder_api_key'),
        metadata: t('integration:enotas_empresa_id'),
        placeholder_metadata: t('integration:enotas_empresa_id_placeholder'),
        enotas_note_type: t('integration:notazz_note_type_label'),
      }}
    />
  );
}
